import { Box, Typography } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { PieChartStyles } from './PieChartStyles';

interface PieData {
  name: string;
  value: number;
}

interface PieChartProps {
  title: string;
  data: PieData[];
  colors?: string[];
  legendGrid?: { columns?: number };
}

const DEFAULT_COLORS = ['#7C2AE8', '#A259F7', '#C084FC', '#DDD6FE', '#E9D5FF'];

const CustomPieChart: React.FC<PieChartProps> = ({
  title,
  data,
  colors = DEFAULT_COLORS,
  legendGrid = { columns: 2 }
}) => (
  <Box sx={PieChartStyles.PieChartContainer}>
    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
      {title}
    </Typography>
    {data.length === 0 ? (
      <Typography 
        textAlign="center" 
        sx={{ height: '300px', display: 'flex', alignItems: 'start', justifyContent: 'center' }}
      >
        No records found
      </Typography>
    ) : (
      <>
        <PieChart width={400} height={300}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ value, percent }) => `${value} (${Math.round(percent * 100)}%)`}
            outerRadius={100}
            dataKey="value"
          >
            {data.map((_, idx) => (
              <Cell key={`cell-${idx}`} fill={colors[idx % colors.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(${legendGrid.columns || 2}, auto)`,
            gap: 2,
            mt: 2,
          }}
        >
          {data.map((entry, idx) => (
            <Box key={entry.name} sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 16, height: 16, background: colors[idx % colors.length], mr: 1, borderRadius: 1 }} />
              <Typography variant="body2">
                {entry.name}: <b>{entry.value}</b>
              </Typography>
            </Box>
          ))}
        </Box>
      </>
    )}
  </Box>
);

export default CustomPieChart;